import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { useForm, ValidationError } from '@formspree/react'
import check from '../img/check.svg'
import '../sass/contact.sass';

function Contact() {
  const { t } = useTranslation();
  const [state, handleSubmit] = useForm("mjkwqlyr");

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  if (state.succeeded) {
    return(
      <div className='d-flex align-items-center contactForm'>
        <i className='successIcon'><img src={check} alt="Success Icon" /></i>{t('successMsg')}
      </div>
    );
  }

  return (
    <div className='container'>
      <h1 className='text-center'>{t('contactFormTitle')}</h1>
      <form onSubmit={handleSubmit} id='contactF' className='d-flex justify-content-center flex-column contactForm'>
        <div className='form-fields'>
          <label htmlFor="name" className='d-block'>{t('yourName')}</label>
          <input type='text' id="name" name="name" />
        </div>
        <div className='form-fields'>
          <label htmlFor="email" className='d-block'>{t('emailAddress')}</label>
          <input type='email' id="email" name="email" placeholder='example@domain.com' required />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>
        <div className='form-fields'>
          <label htmlFor="message" className='d-block'>{t('message')}</label>
          <textarea id="message" name="message" placeholder='Type message...' rows="6" required></textarea>
          <ValidationError prefix="Message" field="message" errors={state.errors} />
        </div>
        <button className='btn' type="submit" disabled={state.submitting}>{t('submit')}</button>
      </form>
    </div>
  );
}

export default Contact;